module.exports = __webpack_public_path__ + "img/icone-propeller.1c83914e.svg";